import React from 'react';

class Footer extends React.Component {
  render() {
    return (
      <footer className="footer text-center">
        © 2019. Miracle Messages{' '}
        <a href="https://miraclemessages.org/">Miracle Messages</a>.
      </footer>
    );
  }
}
export default Footer;
